export default __webpack_public_path__ + "static/media/times-circle.99caf651.svg";